import { authHttp } from '../http'
import * as routes from '../../routes/picking.routes'
import { errorHandler } from '../../../util/error.service'

export async function saveEquipe({ id, name, tp_id, actived }) {
  try {
    let response
    if (id) {
      response = await authHttp().put(routes.urlPostPutEquipeSeparacao, {
        id,
        name,
        tp_id,
        actived,
      })
    } else {
      response = await authHttp().post(routes.urlPostPutEquipeSeparacao, { name, tp_id, actived })
    }
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
export async function getEquipes(tp_id) {
  try {
    const response = await authHttp().get(routes.urlGetEquipesSeparacao(tp_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
